import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };

type State = { hasError: boolean; error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) {
      console.error('ErrorBoundary', error, info.componentStack);
    }
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div className="si-wrap">
          <div className="si-card" style={{ width: 480 }}>
            <div className="si-title">Something went wrong</div>
            <div className="si-sub">
              The application hit an unexpected error. Try reloading the page. If the problem continues, contact support.
            </div>
            {import.meta.env.DEV ? (
              <pre style={{ padding: 12, background: '#f7f6f2', borderRadius: 8, overflow: 'auto', marginBottom: 12 }}>
                {this.state.error.message}
              </pre>
            ) : null}
            <button className="btn-si" type="button" onClick={() => window.location.reload()}>
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
